<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <form @submit.prevent="validateBeforeSubmit" class="row ls-form">
      <div>
        <div class="col-md-4">
          <h3 class="ls-title-4">{{ $t('settings.main.account_information') }}</h3>
          <p>{{ $t('settings.main.describe_account_information') }}</p>
        </div>
        <div class="col-md-8 ls-lg-margin-bottom">
          <div class="row" v-if="seller.cnpj">
            <label class="ls-label col-md-9 col-lg-4" :class="{'ls-error': errors.has($t('settings.main.company_name')) }">
            <span class="ls-label-text">{{ $t('settings.main.company_name') }}</span>
            <input
              type="text"
              v-model="companyName"
              v-validate.initial="'required'"
              :placeholder="$t('settings.placeholder.company_name')"
              :name="$t('settings.main.company_name')" />
            <small class="ls-help-message" v-show="errors.has($t('settings.main.company_name'))">{{ errors.first($t('settings.main.company_name')) }}</small>
            </label>

          </div>

          <div class="row">

            <label class="ls-label col-md-9 col-lg-4" :class="{'ls-error': errors.has($t('settings.main.company_name')) }">
              <span class="ls-label-text">{{ $t('settings.main.trade_name') }}</span>
              <input
                type="text"
                v-model="tradeName"
                v-validate.initial="'required'"
                :placeholder="$t('settings.placeholder.trade_name')"
                :name="$t('settings.main.trade_name')" />
              <small class="ls-help-message" v-show="errors.has($t('settings.main.trade_name'))">{{ errors.first($t('settings.main.trade_name')) }}</small>
            </label>

          </div>

          <div class="row">

            <label class="ls-label col-md-9 col-lg-4" :class="{'ls-error': errors.has($t('settings.main.name')) }">
            <span class="ls-label-text">{{ $t('settings.main.name') }}</span>
            <input
              name="seller.name"
              type="text"
              v-model="name"
              v-validate="'required'"
              :placeholder="$t('settings.placeholder.name')"
              :name="$t('settings.main.name')" />
            <small class="ls-help-message" v-show="errors.has($t('settings.main.name'))">{{ errors.first($t('settings.main.name')) }}</small>
            </label>

          </div>
          <div class="row">

            <label class="ls-label col-md-9 col-lg-4" :class="{'ls-error': errors.has($t('settings.main.telephone')) }">
            <span class="ls-label-text">{{ $t('settings.main.telephone') }}</span>
            <input
              type="tel"
              maxlength="16"
              v-model="fullPhone"
              v-validate="'required|min:14'"
              v-mask="phoneMask"
              :placeholder="$t('settings.placeholder.telephone')"
              :name="$t('settings.main.telephone')" />
            <small class="ls-help-message" v-show="errors.has($t('settings.main.telephone'))">{{ errors.first($t('settings.main.telephone')) }}</small>
            </label>

            <label class="ls-label col-md-9 col-lg-4">
              <span class="ls-label-text">{{ $t('settings.main.yapay_token') }}</span>
              <input type="text"
                v-model="yapayTokenValue"
               :name="$t('settings.main.yapay_token')">
            </label>

            <label class="ls-label col-md-12">
              <b class="ls-label-text">{{ $t('settings.main.seller_code') }}</b>
              <p>{{ seller.code }}</p>
            </label>

          </div>
        </div>
        <div class="ls-clearfix"></div>
        <div class="col-md-4">
          <h3 class="ls-title-4">{{ $t('settings.main.your_location') }}</h3>
          <p>{{ $t('settings.main.describe_your_location') }}</p>
        </div>
        <div class="col-md-8 ls-lg-margin-bottom">
          <div class="row">

            <label class="ls-label col-xs-6 col-sm-6 col-md-6 col-lg-4 ls-float-left" :class="{'ls-error': errors.has($t('settings.main.postal_code')) }">
              <span class="ls-label-text">{{ $t('settings.main.postal_code') }}</span>
              <input
                type="tel"
                maxlength="10"
                v-model="postalCode"
                v-mask="'99.999-999'"
                v-validate="'required|min:10|cep'"
                :placeholder="$t('settings.placeholder.postal_code')"
                :name="$t('settings.main.postal_code')" />
              <small class="ls-help-message" v-show="errors.has($t('settings.main.postal_code'))">{{ errors.first($t('settings.main.postal_code')) }}</small>
            </label>

            <div class="col-xs-6 col-sm-6 col-md-6 margin-postal-code">
              <p><a href="http://www.buscacep.correios.com.br/sistemas/buscacep/" target="_blank">{{ $t('settings.main.forgot_zipcode') }}</a></p>
            </div>
            <div class="ls-clearfix"></div>
          </div>

          <div v-if="hasAddress">
            <div class="row">

              <label class="ls-label col-xs-6 col-sm-6 col-md-6 col-lg-4 ls-float-left" :class="{'ls-error': errors.has($t('settings.main.address')) }">
                <span class="ls-label-text">{{ $t('settings.main.address') }}</span>
                <input
                  type="text"
                  v-model="street"
                  v-validate="'required'"
                  :placeholder="$t('settings.placeholder.address')"
                  :name="$t('settings.main.address')" />
                <i class="fa fa-spinner fa-spin fa-fw" v-if="loadInput"></i>
                <small class="ls-help-message" v-show="errors.has($t('settings.main.address'))">{{ errors.first($t('settings.main.address')) }}</small>
              </label>

              <label class="ls-label col-sm-3 col-md-3 col-lg-2 col-xs-6 ls-float-left" :class="{'ls-error': errors.has($t('settings.main.number')) }">
                <span class="ls-label-text">{{ $t('settings.main.number') }}</span>
                <input
                  name="seller.address.number"
                  type="text"
                  v-model="number"
                  v-validate="'required'"
                  :placeholder="$t('settings.placeholder.number')"
                  :name="$t('settings.main.number')" />
                <i class="fa fa-spinner fa-spin fa-fw" v-if="loadInput"></i>
                <small class="ls-help-message" v-show="errors.has($t('settings.main.number'))">{{ errors.first($t('settings.main.number')) }}</small>
              </label>

              <div class="ls-clearfix"></div>
            </div>
            <div class="row">

              <label class="ls-label col-xs-12 col-sm-6 col-md-6 col-lg-4" :class="{'ls-error': errors.has($t('settings.main.neighborhood')) }">
                <span class="ls-label-text">
                {{ $t('settings.main.neighborhood') }}
                </span>
                <input
                  name="seller.address.neighborhood"
                  type="text"
                  v-model="neighborhood"
                  v-validate="'required'"
                  :placeholder="$t('settings.placeholder.neighborhood')"
                  :name="$t('settings.main.neighborhood')" />
                <i class="fa fa-spinner fa-spin fa-fw" v-if="loadInput"></i>
                <small class="ls-help-message" v-show="errors.has($t('settings.main.neighborhood'))">{{ errors.first($t('settings.main.neighborhood')) }}</small>
              </label>

            </div>
            <div class="row">

              <label class="ls-label col-sm-6 col-md-6 col-lg-4">
                <span class="ls-label-text">
                {{ $t('settings.main.complement') }}
                <small>({{ $t('settings.main.optional') }})</small>
                </span>
                <input
                  name="complement"
                  type="text"
                  v-model="complement" />
              </label>

            </div>
            <div class="row">

              <label class="ls-label col-sm-6 col-md-6 col-lg-4 col-xs-6 ls-float-left" :class="{'ls-error': errors.has($t('settings.main.city')) }">
                <span class="ls-label-text">{{ $t('settings.main.city') }}</span>
                <input
                  name="seller.address.city"
                  type="text"
                  v-model="city"
                  v-validate="'required'"
                  :placeholder="$t('settings.placeholder.city')"
                  :name="$t('settings.main.city')">
                <i class="fa fa-spinner fa-spin fa-fw" v-if="loadInput"></i>
                <small class="ls-help-message" v-show="errors.has($t('settings.main.city'))">{{ errors.first($t('settings.main.city')) }}</small>
              </label>

              <label class="ls-label col-sm-3 col-md-3 col-lg-2 col-xs-6 ls-float-left">
                <b class="ls-label-text">{{ $t('settings.main.state') }}</b>
                <div class="ls-custom-select" :class="{'ls-error': errors.has('seller.address.state') }">
                  <select
                    class="ls-select"
                    v-model="state"
                    v-validate="'required'"
                    :name="$t('settings.main.state')">
                    <option value="AC">AC</option>
                    <option value="AL">AL</option>
                    <option value="AP">AP</option>
                    <option value="AM">AM</option>
                    <option value="BA">BA</option>
                    <option value="CE">CE</option>
                    <option value="DF">DF</option>
                    <option value="ES">ES</option>
                    <option value="GO">GO</option>
                    <option value="MA">MA</option>
                    <option value="MS">MS</option>
                    <option value="MG">MG</option>
                    <option value="PA">PA</option>
                    <option value="PB">PB</option>
                    <option value="PR">PR</option>
                    <option value="PE">PE</option>
                    <option value="PI">PI</option>
                    <option value="RJ">RJ</option>
                    <option value="RN">RN</option>
                    <option value="RS">RS</option>
                    <option value="RO">RO</option>
                    <option value="RR">RR</option>
                    <option value="SC">SC</option>
                    <option value="SP">SP</option>
                    <option value="SE">SE</option>
                    <option value="TO">TO</option>
                  </select>
                </div>
                <i class="fa fa-spinner fa-spin fa-fw" v-if="loadInput"></i>
                <small class="ls-help-message" v-show="errors.has('seller.address.state')">{{ $t('settings.label.error.field_required') }}</small>
              </label>

              <div class="ls-clearfix"></div>
            </div>
          </div>
          </div>
      </div>
      <div class="ls-clearfix"></div>
      <div class="ls-actions-btn">
        <div class="ls-float-right">
          <router-link to="/" class="ls-btn">{{ $t('application.button.cancel') }} </router-link>
          <button type="submit" class="ls-btn ls-btn-primary">{{ $t('application.button.save') }}</button>
        </div>
        <div class="ls-clearfix"></div>
      </div>
    </form>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import * as types from './vuex/mutations-types'
  import * as format from 'src/utils/form'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'Settings',
    components: { Breadcrumb },
    data () {
      return {
        onlyNumber: /[\D]/g,
        id: '',
        companyName: '',
        tradeName: '',
        name: '',
        street: '',
        number: '',
        neighborhood: '',
        complement: '',
        city: '',
        state: '',
        fullPhone: '',
        postalCode: '',
        addressId: null,
        contactId: null,
        hasAddress: true,
        availabilityMessage: false,
        index: '',
        phoneMask: '',
        loadInput: false,
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.general'),
          'paths': {
            0: {
              'title': this.$t('settings.main.setup'),
              'path': ''
            }
          }
        },
        watchCep: false,
        newSeller: {}
      }
    },
    methods: {
      ...mapMutations(['clearFlash']),
      ...mapActions(['loadUser', 'editSeller', 'getAddress', 'loadYapayToken', 'updateYapayToken']),
      validateBeforeSubmit () {
        this.clearFlash()
        this.$validator.validateAll().then(this.sendForm)
      },
      sendForm (success) {
        this.$loader.show()
        if (success) {
          this.submitForm()
        } else {
          this.$loader.hide()
        }
      },
      submitForm () {
        this.editYapayToken()
        this.prepareParameters()
        this.editSeller({ seller: this.newSeller, message: true }).then(this.afterEdit)
      },
      editYapayToken () {
        let params = { id: 16, value: this.yapayTokenValue }
        this.updateYapayToken(params)
      },
      afterEdit () {
        this.$loader.hide()
        scroll.scrollToFlash()
      },
      prepareParameters () {
        var phoneOnlyNumber = this.fullPhone.replace(/\D/g, '')
        var cep = this.postalCode.replace(/\D/g, '')

        this.newSeller = {}

        this.newSeller.id = this.id
        this.newSeller.name = this.name
        this.newSeller.trade_name = this.tradeName
        this.newSeller.company_name = this.companyName

        this.newSeller.address_attributes = {}
        this.newSeller.address_attributes.id = this.addressId
        this.newSeller.address_attributes.postal_code = cep
        this.newSeller.address_attributes.street = this.street
        this.newSeller.address_attributes.number = this.number
        this.newSeller.address_attributes.complement = this.complement
        this.newSeller.address_attributes.neighborhood = this.neighborhood
        this.newSeller.address_attributes.city = this.city
        this.newSeller.address_attributes.state = this.state

        this.newSeller.contact_attributes = {}
        this.newSeller.contact_attributes.id = this.contactId
        this.newSeller.contact_attributes.area_code = phoneOnlyNumber.substr(0, 2)
        this.newSeller.contact_attributes.number = phoneOnlyNumber.substr(2, 9)
      },
      afterLoadUser (response) {
        if (response.status === 200) {
          this.loadYapayToken({ id: 16 })
          Promise.resolve(this.setFields()).then(this.afterSetFields)
        } else {
          this.watchCep = true
        }
        this.$loader.hide()
      },
      setFields () {
        this.id = this.seller.id
        this.tradeName = this.seller.trade_name
        this.companyName = this.seller.company_name
        this.name = this.seller.name

        this.addressId = this.seller.address.id
        this.street = this.seller.address.street
        this.number = this.seller.address.number
        this.neighborhood = this.seller.address.neighborhood
        this.complement = this.seller.address.complement
        this.city = this.seller.address.city
        this.state = this.seller.address.state
        this.postalCode = format.cep(this.seller.address.postal_code)

        this.contactId = this.seller.contact.id
        this.fullPhone = format.fullPhone(this.seller.contact.area_code + this.seller.contact.number)
      },
      afterSetFields () {
        this.watchCep = true
      }
    },
    computed: {
      ...mapGetters(['addressFound', 'user', 'seller', 'currentUser', 'yapayToken']),
      yapayTokenValue: {
        get () {
          return this.yapayToken || ''
        },
        set (value) {
          this.$store.commit(types.yapayToken, value)
        }
      }

    },
    mounted () {
      this.watchCep = false
      this.loadUser().then(this.afterLoadUser)
    },
    watch: {
      fullPhone: function (newVal) {
        if (this.fullPhone === undefined ||
            this.fullPhone.replace(this.onlyNumber, '').length <= 10) {
          this.phoneMask = '(99) 9999-99999'
        } else {
          this.phoneMask = '(99) 9 9999-9999'
        }
      },
      addressFound: function (value) {
        if (value.address) {
          if (value.address.city) this.hasAddress = true
          if (value.address.street) this.street = value.address.street
          if (value.address.neighborhood) this.neighborhood = value.address.neighborhood
          this.city = value.address.city
          this.state = value.address.state
        }
        this.$loader.hide()
      },
      postalCode: function (newVal, oldVal) {
        if (this.postalCode.length < 10) {
          this.hasAddress = false
          this.street = ''
          this.number = ''
          this.neighborhood = ''
          this.city = ''
          this.state = ''
        } else {
          this.$loader.show()
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .custom-danger {
    border: 1px solid #d75553;
  }
  .no-text-label {
    margin: 22px 0 0 10px;
  }
  .margin-postal-code {
    margin-top: 24px;
  }
  .check-availability {
    display: inline-block;
    padding: 15px;
    @media screen and (min-width: 1348px) {
      padding: 18px 0;
    }
    @media screen and (max-width: 991px) {
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 480px) {
    .ls-prefix-group {
      display: initial;
    }
    .ls-label-text-prefix {
      background: #eaeaea;
      height: 33px;
      &:last-child {
        border-radius: 0;
        left: 0;
      }
    }
    .form-control {
      border: 1px solid #dddddd;
      border-radius: 0;
    }
  }
  .ls-label {
    .fa-spinner {
      position: inherit;
      bottom: -3px;
    }
  }
</style>



// WEBPACK FOOTER //
// Main.vue?05988244